import { render, staticRenderFns } from "./MarkerCategories.vue?vue&type=template&id=5c2e4356"
import script from "./MarkerCategories.vue?vue&type=script&lang=js"
export * from "./MarkerCategories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports